<template>
  <div class="back-top">
    <router-link to="/contact#info">
      <img src="~assets/images/home/back-jiam.png" />
    </router-link>
    <a href="javascript:;" @click="showModel" >
      <img src="~assets/images/home/back-qq.png" />
    </a>
    <img @click="showPopup" src="~assets/images/home/kefu_03.png" />
    <img v-show="isShow" @click="backTop" src="~assets/images/home/back-top.png" />
    <van-popup
      class="popup"
      closeable
      close-icon="close"
      close-icon-position="bottom"
      v-model="show"
      get-container="body"
    >
      <div class="wrap">
        <img src="~assets/images/home/2_06.png?v1" />
        <p>您可截图添加微信了解详情</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      isShow: false,
      show: false
    };
  },
  created() {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 600) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    });
  },
  methods: {
    backTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    getContainer() {
      return document.querySelector(".my-container");
    },
    showPopup() {
      this.show = true;
    },
    showModel() {
      this.$dialog.confirm({
        title:'温馨提示',
        message: '即将跳转至客服QQ，是否继续？',
      }).then(()=>{
        window.location.href = 'mqqwpa://im/chat?chat_type=wpa&uin=1432144275&version=1&src_type=web&web_src=oicqzone.com'
      })
    }
  }
};
</script>

<style scoped lang="less">
.back-top {
  position: fixed;
  right: 32px;
  /*bottom: 60px;*/
  top: 70%;
  z-index: 8;
  display: flex;
  flex-flow: column;
  img {
    background: #fff;
    padding: 16px;
    height: 66px;
    width: 70px;
    outline: 1px solid #efefef;
    box-sizing: border-box;
    margin-bottom: 20px;
  }
}
.van-popup {
  width: 70vw;
  height: 50vh;
}
.popup {
  text-align: center;
  background: transparent;
  .wrap {
    background: #fff;
     padding-top: 40px;
    border-radius: 5px;
  }
  /deep/.van-popup__close-icon {
    font-size: 80px;
    bottom: 0;
    left: 0;
    right: 0;
    background: transparent;
  }
  img {
    width: 80%;
  }
  p {
    font-size: 30px;
    color: #999;
    padding: 15px 0 30px 0;
  }
}
</style>